import useListRowInfStroe from "store/listRowInf";
import { useGetResvData } from "./service";
import useLodStore from "store/lod";
import useMdiStore from "store/menus";
import { PAGE_ID_ROOM_RESV } from "components/constent";
import useAlertStore from "store/alert";

// 예약 상세모달
export const detail = (props: any) => {
  const setListRowParams = useListRowInfStroe.getState().setListRowParams;

  const params = {
    no: props.data.rmPdNo,
    rgSeq: 1,
    btnNm: props.colDef.field,
  };

  setListRowParams(params);
};

// 오늘예약 고객 새로고침
export const useRefreshResv = () => {
  const { mutation } = useGetResvData();
  const lod = useLodStore((state) => state.lod);
  const dayDt = new Date().toISOString().split("T")[0].replaceAll("-", "");

  const onRefresh = () => {
    if (!lod?.lodNo) return;
    if (lod?.lodNo) {
      mutation.mutate({
        lodNo: lod.lodNo,
        dayDt: dayDt,
      });
    }
  };

  return {
    onRefresh,
  };
};

// 오늘예약 고객 더보기 > 예약리스트로 이동
export const onViewMore = () => {
  const { setActivePage } = useMdiStore.getState();
  const { onSetAlert } = useAlertStore.getState();
  onSetAlert({
    isOpen: true,
    inner: "예약리스트 페이로 이동합니다. / 이동하시겠습니까?",
    cnclBtn: true,
    onSetConfirm: () => {
      setActivePage(PAGE_ID_ROOM_RESV);
    },
  });
};
